import { render, staticRenderFns } from "./AdminSwatVersionCreate.vue?vue&type=template&id=12b977ca&"
import script from "./AdminSwatVersionCreate.vue?vue&type=script&lang=js&"
export * from "./AdminSwatVersionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports